export type PlanChangeInput = { currentMax: number; targetMax: number; used: number };
export type PlanChangeDecision = {
  kind: "upgrade" | "downgrade" | "same_capacity";
  allowed: boolean;
  requiresSeatResolution: boolean;
  seatsToFree: number;
};

/**
 * Seat-safe plan change guard (mirrors the stripe-billing `change_plan` server check).
 * A downgrade is only allowed when occupied seats already fit the target capacity.
 * It never deactivates anyone; the owner must free seats explicitly first.
 */
export function evaluatePlanChange({ currentMax, targetMax, used }: PlanChangeInput): PlanChangeDecision {
  const kind = targetMax > currentMax ? "upgrade" : targetMax < currentMax ? "downgrade" : "same_capacity";
  const seatsToFree = Math.max(used - targetMax, 0);
  const allowed = seatsToFree === 0;
  return { kind, allowed, requiresSeatResolution: !allowed, seatsToFree };
}
